export default {
  path: '/2019CQXF',
  name: '2019CQXF',
  component: () => import('./Home.vue'),
  redirect: '/2019CQXF/RelativeNews',
  meta: {
    title: '重庆消防主题宣传',
  },
  children: [
    {
      path: 'RelativeNews',
      component: () => import('./RelativeNews.vue'),
      name: '2019CQXF/RelativeNews',
      meta: {
        title: '重庆消防主题宣传',
      },
    },
    {
      path: 'SelectRules',
      component: () => import('./SelectRules.vue'),
      name: '2019CQXF/SelectRules',
      meta: {
        title: '重庆消防主题宣传',
      },
    },
  ],
};
